/**
 * Admin Navigation Component
 */
import { t } from '../lib/i18n.js';
import { getCurrentUser, logout } from '../lib/keycloak.js';

export async function createNavigation() {
  const nav = document.createElement('nav');
  nav.className = 'admin-nav';

  const currentPath = window.location.pathname;
  const user = await getCurrentUser();
  const userName = user ? escapeHtml(normalizeDisplayText(user.firstName || user.email || 'User')) : '';
  const userRole = user ? escapeHtml(normalizeDisplayText(user.role || 'user')) : '';

  nav.innerHTML = `
    <div class="admin-nav-content">
      <a href="/" class="admin-logo" data-link>
        <img src="/Stroyma_White_transparent.png" alt="Stroyma Admin">
      </a>
      
      <ul class="admin-nav-links">
        <li>
          <a href="/" class="admin-nav-link ${currentPath === '/' ? 'active' : ''}" data-link>
            ${t('nav_dashboard')}
          </a>
        </li>
        <li>
          <a href="/upload" class="admin-nav-link ${currentPath === '/upload' ? 'active' : ''}" data-link>
            ${t('nav_upload')}
          </a>
        </li>
        <li>
          <a href="/manage" class="admin-nav-link ${currentPath === '/manage' ? 'active' : ''}" data-link>
            ${t('nav_manage')}
          </a>
        </li>
        <li>
          <a href="/settings" class="admin-nav-link ${currentPath === '/settings' ? 'active' : ''}" data-link>
            ${t('nav_settings')}
          </a>
        </li>
        <li>
          <a href="https://stroyma.fo" target="_blank" class="btn btn-secondary btn-small" style="white-space: nowrap;">
            ${t('nav_view_site')} →
          </a>
        </li>
        ${
          user
            ? `
          <li style="margin-left: auto; display: flex; align-items: center; gap: 12px;">
            <div class="user-info">
              <span class="user-name">${userName}</span>
              <span class="user-role">${userRole}</span>
            </div>
            <button id="logout-btn" class="btn btn-secondary btn-small">
              ${t('nav_logout')}
            </button>
          </li>
        `
            : ''
        }
      </ul>
    </div>
  `;

  // Add logout handler
  if (user) {
    setTimeout(() => {
      const logoutBtn = document.getElementById('logout-btn');
      if (logoutBtn) {
        logoutBtn.addEventListener('click', (e) => {
          e.preventDefault();
          logout();
        });
      }
    }, 0);
  }

  return nav;
}

function normalizeDisplayText(value) {
  return String(value).normalize('NFC');
}

function escapeHtml(value) {
  return value.replace(/[&<>"']/g, (char) => {
    const entities = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    };

    return entities[char];
  });
}
